module.exports = {"Type":"CallBot","Output":true,"Fields":[{"label":"Bot name","name":"botName"}],"Header":{"Color":"white","BackgroundColor":"cornflowerblue","Text":null}}


//////////////////
// WEBPACK FOOTER
// ./src/designer/widgets/CallBot.json
// module id = 682
// module chunks = 0